import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import PageHero from "../components/PageHero";
import FinalCta from "../components/FinalCta";
import { TESTIMONIALS, IMG } from "../lib/content";

const more = [
  {
    quote: "Genuinely transformative. The terrazzo in our hallway looks better than it has in 30 years.",
    name: "Charles W.",
    role: "Homeowner · Paddington",
  },
  {
    quote: "From quote to completion, every detail was handled. Final finish is genuinely flawless.",
    name: "Aisha K.",
    role: "Architect · Surry Hills",
  },
  {
    quote: "Used by every trades-savvy designer I know in Sydney. There's a reason.",
    name: "Liam B.",
    role: "Property Stylist · Bondi",
  },
];

const all = [...TESTIMONIALS, ...more];

export default function Reviews() {
  return (
    <main data-testid="reviews-page">
      <PageHero
        eyebrow="Client Reviews"
        title="Five-star service,"
        italic="word for word."
        subtitle="An average client rating of 5.0 across hundreds of completed projects in Sydney."
        image={IMG.greyMarbleBathroom}
      />

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {all.map((t, i) => (
            <motion.figure
              key={t.name + i}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.06 }}
              className="bg-white border border-black/10 p-8 md:p-10 hover-lift hover:border-[#C9A86A] hover:shadow-[0_24px_60px_-30px_rgba(0,0,0,0.18)]"
            >
              <div className="flex gap-1 text-[#C9A86A]">
                {[...Array(5)].map((_, k) => (<Star key={k} className="w-4 h-4 fill-[#C9A86A]" strokeWidth={0} />))}
              </div>
              <blockquote className="mt-6 font-serif-italic text-xl text-[#0A0A0A]/85 leading-relaxed">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3">
                <span className="block w-10 h-px bg-[#C9A86A]" />
                <div>
                  <div className="text-[#0A0A0A] text-sm">{t.name}</div>
                  <div className="text-[#525252] text-[11px] uppercase tracking-[0.22em] mt-1">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </section>

      <FinalCta />
    </main>
  );
}
